import { cn } from '../../lib/cn'
import { Text } from './Text'

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string
  error?: string
  hint?: string
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  containerClassName?: string
}

export function Input({
  label,
  error,
  hint,
  leftIcon,
  rightIcon,
  className,
  containerClassName,
  id,
  ...props
}: InputProps) {
  const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-')

  return (
    <div className={cn('flex flex-col gap-1.5', containerClassName)}>
      {label && (
        <Text as="label" variant="label" htmlFor={inputId}>
          {label}
        </Text>
      )}
      <div className="relative">
        {leftIcon && (
          <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-foreground/50">
            {leftIcon}
          </span>
        )}
        <input
          id={inputId}
          className={cn(
            'h-11 w-full rounded-full border border-foreground/20 bg-white px-4 text-sm text-foreground',
            'placeholder:text-foreground/40',
            'focus:border-foreground focus:outline-none',
            'disabled:cursor-not-allowed disabled:opacity-50',
            leftIcon && 'pl-11',
            rightIcon && 'pr-11',
            error && 'border-red-500 focus:border-red-500',
            className,
          )}
          {...props}
        />
        {rightIcon && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2">{rightIcon}</span>
        )}
      </div>
      {error && (
        <Text variant="caption" className="text-red-600">
          {error}
        </Text>
      )}
      {!error && hint && <Text variant="caption">{hint}</Text>}
    </div>
  )
}
